module.exports = __webpack_public_path__ + "static/media/search.3c060a9e.svg";